<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Donor Acceptability Criteria EMR Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3" v-if="organ === 'Kidney' || organ === 'Liver' || organ === 'Lung'">
            <ADSTextInput
              v-model="preferredDonorType"
              disabled
              label="Preferred Donor Type"
              class="preferredDonorType"
            />
          </div>
          <div class="col-2" v-if="organ === 'Kidney' || organ === 'Pancreas'">
            <ADSTextInput
              v-model="acceptHepBCore"
              disabled
              label="Accept Hep B Core Ab+ Donor"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="acceptA2A2BDonor"
              disabled
              label="Accept A2 or A2B Donor"
            />
          </div>

        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="acceptABOIncompatibleDonor"
              disabled
              label="Accept ABO Incompatible Donor"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="acceptHCVAbPlusDonor"
              disabled
              label="Accept HCV Ab+ Donor"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="acceptHCVNATPlusDonor"
              disabled
              label="Accept HCV NAT+ Donor"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2" v-if="organ === 'Kidney'">
            <ADSTextInput
              id="disabled-text"
              v-model="acceptExtendedCriteriaDonor"
              disabled
              label="Accept Extended Criteria Donor"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="comments"
              disabled
              label="Comments"
              class="comments"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "DonorAcceptabilitySectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    organ: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      acceptHepBCore: this.getAcceptHepBCore( this.patientBundle ),
      preferredDonorType: this.getPreferredDonorType( this.patientBundle ),
      acceptA2A2BDonor: this.getAcceptA2A2BDonor( this.patientBundle ),
      acceptABOIncompatibleDonor: this.getAcceptABOIncompatibleDonor( this.patientBundle ),
      acceptHCVAbPlusDonor: this.getAcceptHCVAbPlusDonor( this.patientBundle ),
      acceptHCVNATPlusDonor: this.getAcceptHCVNATPlusDonor( this.patientBundle ),
      acceptExtendedCriteriaDonor: this.getAcceptExtendedCriteriaDonor( this.patientBundle ),
      comments: this.getDonorAcceptanceComments( this.patientBundle )
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === observationCode && 
      _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getRecipientStatus( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4123' );
    },
    getAcceptHepBCore( patientBundle ) {
      const value = this.getSmartdataComponentValue( patientBundle, 'UHN#4004', 'valueBoolean' );
      if ( value === null ) {
        return '';
      }
      return value === 'true' ? 'Yes' : 'No';
    },
    getPreferredDonorType( patientBundle ) {
      const value = this.getSmartdataComponentValue( patientBundle, 'UHN#4003' );
      if ( value === null ) {
        return '';
      }
      return value;
    },
    getAcceptA2A2BDonor( patientBundle ) {
      const value = this.getSmartdataComponentValue( patientBundle, 'UHN#4005', 'valueBoolean' );
      if ( value === null ) {
        return '';
      }
      return value === 'true' ? 'Yes' : 'No';
    },
    getAcceptABOIncompatibleDonor( patientBundle ) {
      const value = this.getSmartdataComponentValue( patientBundle, 'UHN#4006', 'valueBoolean' );
      if ( value === null ) {
        return '';
      }
      return value === 'true' ? 'Yes' : 'No';
    },
    getAcceptHCVAbPlusDonor( patientBundle ) {
      const value = this.getSmartdataComponentValue( patientBundle, 'UHN#4007', 'valueBoolean' );
      if ( value === null ) {
        return '';
      }
      return value === 'true' ? 'Yes' : 'No';
    },
    getAcceptHCVNATPlusDonor( patientBundle ) {
      const value = this.getSmartdataComponentValue( patientBundle, 'UHN#4008', 'valueBoolean' );
      if ( value === null ) {
        return '';
      }
      return value === 'true' ? 'Yes' : 'No';
    },
    getAcceptExtendedCriteriaDonor( patientBundle ) {
      const value = this.getSmartdataComponentValue( patientBundle, 'UHN#4009', 'valueBoolean' );
      if ( value === null ) {
        return '';
      }
      return value === 'true' ? 'Yes' : 'No';
    },
    getDonorAcceptanceComments( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4010' );
    },
    
  },
};
</script>

<style scoped>

/* .card {
  height: 350px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 350px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.inputDisplayPreferredDonorType {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.preferredDonorType .afflo-ds-form-control) {
  width: 300px;
}

:deep(.comments .afflo-ds-form-control) {
  width: 300px;
}

</style>
